<form class="flex flex-col gap-4 text-sm" (ngSubmit)="save()">
  @switch (form) {
  <!-- ID externo -->
  @case ('external_id') {
  <label class="flex flex-col gap-1">
    <span class="font-semibold">ID externo de la ONU</span>
    <input pInputText name="client_external_id" [(ngModel)]="model['client_external_id']" />
    <small class="text-gray-500"
      >Identificador único usado por la API y sistemas de facturación.</small
    >
  </label>
  }

  <!-- Ubicación -->
  @case ('location') {
  <div class="grid grid-cols-1 gap-3 md:grid-cols-2">
    <label class="flex flex-col gap-1">
      <span class="font-semibold">Zona</span>
      <p-dropdown
        name="zone_id"
        [options]="lists['zones'] ?? []"
        optionLabel="label"
        optionValue="value"
        [filter]="true"
        [loading]="!!loading['zones']"
        appendTo="body"
        styleClass="w-full"
        [(ngModel)]="model['zone_id']"
        (onChange)="onZoneChange()"
      />
    </label>
    <label class="flex flex-col gap-1">
      <span class="font-semibold">Splitter (ODB)</span>
      <p-dropdown
        name="odb_id"
        [options]="lists['odbs'] ?? []"
        optionLabel="label"
        optionValue="value"
        [filter]="true"
        [showClear]="true"
        [loading]="!!loading['odbs']"
        appendTo="body"
        styleClass="w-full"
        placeholder="Ninguno"
        [(ngModel)]="model['odb_id']"
        (onChange)="onOdbChange()"
      />
    </label>
    <label class="flex flex-col gap-1">
      <span class="font-semibold">Puerto del splitter</span>
      <p-dropdown
        name="odb_port"
        [options]="lists['odb_ports'] ?? []"
        optionLabel="label"
        optionValue="value"
        [showClear]="true"
        [loading]="!!loading['odb_ports']"
        appendTo="body"
        styleClass="w-full"
        placeholder="Ninguno"
        [(ngModel)]="model['odb_port']"
      />
    </label>
    <label class="flex flex-col gap-1">
      <span class="font-semibold">Sector</span>
      <p-dropdown
        name="sector_id"
        [options]="lists['sectors'] ?? []"
        optionLabel="label"
        optionValue="value"
        [showClear]="true"
        [loading]="!!loading['sectors']"
        appendTo="body"
        styleClass="w-full"
        placeholder="Ninguno"
        [(ngModel)]="model['sector_id']"
      />
    </label>
    <label class="flex flex-col gap-1 md:col-span-2">
      <span class="font-semibold">Nombre</span>
      <input
        pInputText
        name="location_name"
        maxlength="100"
        appOnuText
        [class.p-invalid]="fieldErrors['location_name']"
        (invalidChars)="onInvalidChars('location_name', $event)"
        (validInput)="clearFieldError('location_name')"
        [(ngModel)]="model['location_name']"
      />
      @if (fieldErrors['location_name']; as error) {
      <small class="text-red-600">{{ error }}</small>
      }
    </label>
    <label class="flex flex-col gap-1 md:col-span-2">
      <span class="font-semibold">Dirección o comentario</span>
      <input
        pInputText
        name="description"
        maxlength="200"
        appOnuText
        [class.p-invalid]="fieldErrors['description']"
        (invalidChars)="onInvalidChars('description', $event)"
        (validInput)="clearFieldError('description')"
        [(ngModel)]="model['description']"
      />
      @if (fieldErrors['description']; as error) {
      <small class="text-red-600">{{ error }}</small>
      }
    </label>
    <label class="flex flex-col gap-1">
      <span class="font-semibold">Contacto</span>
      <input
        pInputText
        name="contact"
        maxlength="60"
        appOnuText
        [class.p-invalid]="fieldErrors['contact']"
        (invalidChars)="onInvalidChars('contact', $event)"
        (validInput)="clearFieldError('contact')"
        [(ngModel)]="model['contact']"
      />
      @if (fieldErrors['contact']; as error) {
      <small class="text-red-600">{{ error }}</small>
      }
    </label>
    <div class="grid grid-cols-2 gap-2">
      <label class="flex flex-col gap-1">
        <span class="font-semibold">Latitud</span>
        <input pInputText name="latitude" [(ngModel)]="model['latitude']" />
      </label>
      <label class="flex flex-col gap-1">
        <span class="font-semibold">Longitud</span>
        <input pInputText name="longitude" [(ngModel)]="model['longitude']" />
      </label>
    </div>
  </div>
  }

  <!-- Tipo de ONU -->
  @case ('onu_type') {
  <label class="flex flex-col gap-1">
    <span class="font-semibold">Tipo de ONU</span>
    <p-dropdown
      name="onu_type_id"
      [options]="lists['onu_types'] ?? []"
      optionLabel="label"
      optionValue="value"
      [filter]="true"
      [loading]="!!loading['onu_types']"
      appendTo="body"
      styleClass="w-full"
      [(ngModel)]="model['onu_type_id']"
    />
  </label>
  <label class="flex flex-col gap-1">
    <span class="font-semibold">Perfil personalizado</span>
    <p-dropdown
      name="custom_template_id"
      [options]="view.options['custom_template_id'] ?? []"
      optionLabel="label"
      optionValue="value"
      appendTo="body"
      styleClass="w-full"
      [(ngModel)]="model['custom_template_id']"
    />
  </label>
  }

  <!-- Reemplazar SN -->
  @case ('sn') {
  <p class="rounded bg-yellow-50 p-2 text-yellow-800">
    La configuración de la ONU actual ({{ view.sn }}) se aplicará al equipo con el nuevo SN.
  </p>
  <label class="flex flex-col gap-1">
    <span class="font-semibold">Nuevo SN</span>
    <input pInputText name="sn" [placeholder]="view.sn" [(ngModel)]="model['sn']" />
  </label>
  <label class="flex flex-col gap-1">
    <span class="font-semibold">Tipo de ONU</span>
    <p-dropdown
      name="new_sn_onu_type_id"
      [options]="lists['onu_types'] ?? []"
      optionLabel="label"
      optionValue="value"
      [filter]="true"
      [loading]="!!loading['onu_types']"
      appendTo="body"
      styleClass="w-full"
      [(ngModel)]="model['new_sn_onu_type_id']"
    />
  </label>
  }

  <!-- Mover ONU -->
  @case ('move') {
  <label class="flex flex-col gap-1">
    <span class="font-semibold">OLT</span>
    <p-dropdown
      name="change_olt_id"
      [options]="lists['olts'] ?? []"
      optionLabel="label"
      optionValue="value"
      [loading]="!!loading['olts']"
      appendTo="body"
      styleClass="w-full"
      [(ngModel)]="model['change_olt_id']"
      (onChange)="onOltChange()"
    />
  </label>
  <div class="grid grid-cols-2 gap-3">
    <label class="flex flex-col gap-1">
      <span class="font-semibold">Tarjeta</span>
      <p-dropdown
        name="change_board"
        [options]="lists['olt_boards'] ?? []"
        optionLabel="label"
        optionValue="value"
        [loading]="!!loading['olt_boards']"
        appendTo="body"
        styleClass="w-full"
        [(ngModel)]="model['change_board']"
        (onChange)="onBoardChange()"
      />
    </label>
    <label class="flex flex-col gap-1">
      <span class="font-semibold">Puerto</span>
      <p-dropdown
        name="change_port"
        [options]="lists['olt_ports'] ?? []"
        optionLabel="label"
        optionValue="value"
        [loading]="!!loading['olt_ports']"
        appendTo="body"
        styleClass="w-full"
        [(ngModel)]="model['change_port']"
      />
    </label>
  </div>
  <label class="flex items-center gap-2">
    <p-checkbox
      name="move_to_default_vlan"
      [binary]="true"
      [(ngModel)]="model['move_to_default_vlan']"
    />
    Cambiar la VLAN principal a la VLAN por defecto del puerto PON destino
  </label>
  }

  <!-- ONU ID asignado -->
  @case ('allocated') {
  <p>
    ONU ID actual: <strong>{{ view.onu.currentOnuId }}</strong>. La ONU se desconectará brevemente y
    se resincronizará.
  </p>
  <label class="flex flex-col gap-1">
    <span class="font-semibold">ONU ID destino</span>
    <p-dropdown
      name="target_onu_id"
      [options]="lists['available_onu_ids'] ?? []"
      optionLabel="label"
      optionValue="value"
      [filter]="true"
      [loading]="!!loading['available_onu_ids']"
      appendTo="body"
      styleClass="w-full"
      [(ngModel)]="model['target_onu_id']"
    />
  </label>
  }

  <!-- Canal GPON -->
  @case ('gpon_type') {
  <div class="flex flex-wrap gap-4">
    @for (type of gponTypes; track type.value) {
    <label class="flex items-center gap-2">
      <p-radioButton name="gpon_type" [value]="type.value" [(ngModel)]="model['gpon_type']" />
      {{ type.label }}
    </label>
    }
  </div>
  <small class="text-gray-500">
    SmartOLT asigna ONU IDs 1-128 al canal GPON y 129-256 a XG/XGS-PON.
  </small>
  <p class="rounded bg-yellow-50 p-2 text-xs text-yellow-800">
    Al cambiar el canal SmartOLT reasigna el ONU ID de la ONU (por ejemplo de <strong>:1</strong> a
    otro número) y la resincroniza. Puede devolverlo desde "Cambiar ONU ID asignado".
  </p>
  }

  <!-- Velocidad -->
  @case ('speed') {
  <label class="flex flex-col gap-1">
    <span class="font-semibold">Descarga</span>
    <p-dropdown
      name="download_speed"
      [options]="view.options['download_speed'] ?? []"
      optionLabel="label"
      optionValue="value"
      [filter]="true"
      appendTo="body"
      styleClass="w-full"
      [(ngModel)]="model['download_speed']"
    />
  </label>
  <label class="flex flex-col gap-1">
    <span class="font-semibold">Subida</span>
    <p-dropdown
      name="upload_speed"
      [options]="view.options['upload_speed'] ?? []"
      optionLabel="label"
      optionValue="value"
      [filter]="true"
      appendTo="body"
      styleClass="w-full"
      [(ngModel)]="model['upload_speed']"
    />
  </label>
  }

  <!-- Modo ONU / WAN -->
  @case ('mode') {
  <label class="flex flex-col gap-1">
    <span class="font-semibold">{{ model['mode'] === 'Routing' ? 'WAN VLAN-ID' : 'VLAN-ID' }}</span>
    <p-dropdown
      name="default_vlan_id"
      [options]="lists['vlans_default'] ?? []"
      optionLabel="label"
      optionValue="value"
      [filter]="true"
      [loading]="!!loading['vlans_default']"
      appendTo="body"
      styleClass="w-full"
      [(ngModel)]="model['default_vlan_id']"
    />
    <small class="text-gray-500">Después de cambiar la VLAN, revise los puertos Ethernet.</small>
  </label>
  <div class="flex flex-wrap items-center gap-4">
    <span class="font-semibold">Modo</span>
    @for (mode of ['Routing', 'Bridging']; track mode) {
    <label class="flex items-center gap-2">
      <p-radioButton name="mode" [value]="mode" [(ngModel)]="model['mode']" />{{ mode }}
    </label>
    }
  </div>
  @if (model['mode'] === 'Routing') {
  <div class="flex flex-wrap items-center gap-4">
    <span class="font-semibold">WAN</span>
    @for (mode of routerModes; track mode) {
    <label class="flex items-center gap-2">
      <p-radioButton name="router_mode" [value]="mode" [(ngModel)]="model['router_mode']" />{{ mode
      }}
    </label>
    }
  </div>
  @if (model['router_mode'] !== 'Setup via ONU webpage') {
  <div class="flex flex-wrap items-center gap-4">
    <span class="font-semibold">Método</span>
    <label class="flex items-center gap-2">
      <p-radioButton
        name="configuration_method"
        value="OMCI"
        [(ngModel)]="model['configuration_method']"
      />OMCI
    </label>
    <label class="flex items-center gap-2">
      <p-radioButton
        name="configuration_method"
        value="TR069"
        [disabled]="view.tr069Profile === 'Inactive'"
        [(ngModel)]="model['configuration_method']"
      />TR069 @if (view.tr069Profile === 'Inactive') {
      <small class="text-gray-500">(inactivo)</small>
      }
    </label>
  </div>
  } @if (model['router_mode'] === 'Static') {
  <div class="grid grid-cols-1 gap-3 md:grid-cols-2">
    <label class="flex flex-col gap-1">
      <span class="font-semibold">IPv4</span>
      <input
        pInputText
        name="ip_address"
        placeholder="150.0.10.25 o 150.0.10.25/24"
        [(ngModel)]="model['ip_address']"
      />
    </label>
    <label class="flex flex-col gap-1">
      <span class="font-semibold">Máscara</span>
      <input pInputText name="subnet_mask" [(ngModel)]="model['subnet_mask']" />
    </label>
    <label class="flex flex-col gap-1">
      <span class="font-semibold">Gateway</span>
      <input pInputText name="gateway" [(ngModel)]="model['gateway']" />
    </label>
    <div class="grid grid-cols-2 gap-2">
      <label class="flex flex-col gap-1">
        <span class="font-semibold">DNS 1</span>
        <input pInputText name="dns1" [(ngModel)]="model['dns1']" />
      </label>
      <label class="flex flex-col gap-1">
        <span class="font-semibold">DNS 2</span>
        <input pInputText name="dns2" [(ngModel)]="model['dns2']" />
      </label>
    </div>
  </div>
  } @if (model['router_mode'] === 'PPPoE') {
  <div class="grid grid-cols-1 gap-3 md:grid-cols-2">
    <label class="flex flex-col gap-1">
      <span class="font-semibold">Usuario PPPoE</span>
      <input pInputText name="username" autocomplete="off" [(ngModel)]="model['username']" />
    </label>
    <label class="flex flex-col gap-1">
      <span class="font-semibold">Contraseña PPPoE</span>
      <input
        pInputText
        name="pppoePassword"
        autocomplete="off"
        [(ngModel)]="model['pppoePassword']"
      />
    </label>
  </div>
  }
  <label class="flex flex-col gap-1">
    <span class="font-semibold">Acceso remoto WAN</span>
    <p-dropdown
      name="allow_remote_access"
      [options]="view.options['allow_remote_access'] ?? []"
      optionLabel="label"
      optionValue="value"
      appendTo="body"
      styleClass="w-full"
      [(ngModel)]="model['allow_remote_access']"
    />
  </label>
  }
  <label class="flex items-center gap-2">
    <p-checkbox name="ip_dhcp_snooping" [binary]="true" [(ngModel)]="model['ip_dhcp_snooping']" />
    IP DHCP-Snooping
  </label>
  }

  <!-- Gestión / VoIP -->
  @case ('mgmt') {
  <label class="flex flex-col gap-1">
    <span class="font-semibold">Perfil TR069</span>
    <p-dropdown
      name="tr069_profile_id"
      [options]="view.options['tr069_profile_id'] ?? []"
      optionLabel="label"
      optionValue="value"
      appendTo="body"
      styleClass="w-full"
      [(ngModel)]="model['tr069_profile_id']"
    />
  </label>
  @if (model['tr069_profile_id'] && model['tr069_profile_id'] !== '0') {
  <div class="flex flex-wrap items-center gap-4">
    <span class="font-semibold">Interfaz TR069</span>
    <label class="flex items-center gap-2">
      <p-radioButton
        name="tr069_interface"
        value="mgmt"
        [(ngModel)]="model['tr069_interface']"
      />Mgmt IP
    </label>
    <label class="flex items-center gap-2">
      <p-radioButton name="tr069_interface" value="wan" [(ngModel)]="model['tr069_interface']" />WAN
    </label>
  </div>
  }
  <div class="flex flex-wrap items-center gap-4">
    <span class="font-semibold">Mgmt IP</span>
    @for (mode of ['Inactive', 'Static', 'DHCP']; track mode) {
    <label class="flex items-center gap-2">
      <p-radioButton name="mgmt_ip_mode" [value]="mode" [(ngModel)]="model['mgmt_ip_mode']" />{{
      mode }}
    </label>
    }
  </div>
  @if (model['mgmt_ip_mode'] !== 'Inactive') {
  <label class="flex items-center gap-2">
    <p-checkbox
      name="mgmt_ip_allow_remote_access"
      [binary]="true"
      [(ngModel)]="model['mgmt_ip_allow_remote_access']"
    />
    Permitir acceso remoto a la Mgmt IP
  </label>
  <label class="flex flex-col gap-1">
    <span class="font-semibold">Mgmt VLAN-ID</span>
    <p-dropdown
      name="mgmt_ip_vlan_id"
      [options]="lists['vlans_mgmt'] ?? []"
      optionLabel="label"
      optionValue="value"
      [loading]="!!loading['vlans_mgmt']"
      emptyMessage="La OLT no tiene VLANs de gestión"
      appendTo="body"
      styleClass="w-full"
      [(ngModel)]="model['mgmt_ip_vlan_id']"
    />
  </label>
  } @if (model['mgmt_ip_mode'] === 'Static') {
  <label class="flex flex-col gap-1">
    <span class="font-semibold">IP de gestión</span>
    <p-dropdown
      name="mgmt_ip_address"
      [options]="lists['mgmt_ips'] ?? []"
      optionLabel="label"
      optionValue="value"
      [filter]="true"
      [loading]="!!loading['mgmt_ips']"
      appendTo="body"
      styleClass="w-full"
      [(ngModel)]="model['mgmt_ip_address']"
      (onChange)="onMgmtIpChange()"
    />
  </label>
  <div class="grid grid-cols-2 gap-2">
    <label class="flex flex-col gap-1">
      <span class="font-semibold">Máscara</span>
      <input pInputText name="mgmt_ip_subnet_mask" [(ngModel)]="model['mgmt_ip_subnet_mask']" />
    </label>
    <label class="flex flex-col gap-1">
      <span class="font-semibold">Gateway</span>
      <input
        pInputText
        name="mgmt_ip_default_gateway"
        [(ngModel)]="model['mgmt_ip_default_gateway']"
      />
    </label>
    <label class="flex flex-col gap-1">
      <span class="font-semibold">DNS 1</span>
      <input pInputText name="mgmt_ip_dns1" [(ngModel)]="model['mgmt_ip_dns1']" />
    </label>
    <label class="flex flex-col gap-1">
      <span class="font-semibold">DNS 2</span>
      <input pInputText name="mgmt_ip_dns2" [(ngModel)]="model['mgmt_ip_dns2']" />
    </label>
  </div>
  }
  <div class="flex flex-wrap items-center gap-4 border-t pt-3">
    <span class="font-semibold">VoIP</span>
    <label class="flex items-center gap-2">
      <p-radioButton
        name="voip_mode"
        value="Disabled"
        [(ngModel)]="model['voip_mode']"
      />Deshabilitado
    </label>
    <label class="flex items-center gap-2">
      <p-radioButton name="voip_mode" value="Enabled" [(ngModel)]="model['voip_mode']" />Habilitado
    </label>
  </div>
  @if (model['voip_mode'] === 'Enabled') {
  <div class="flex flex-wrap items-center gap-4">
    <span class="font-semibold">Adjuntar VoIP a</span>
    <label class="flex items-center gap-2">
      <p-radioButton name="voip_attach_to" value="Mgmt" [(ngModel)]="model['voip_attach_to']" />Mgmt
    </label>
    <label class="flex items-center gap-2">
      <p-radioButton name="voip_attach_to" value="WAN" [(ngModel)]="model['voip_attach_to']" />WAN
    </label>
  </div>
  } }

  <!-- VLANs adjuntas -->
  @case ('vlans') {
  <label class="flex flex-col gap-1">
    <span class="font-semibold">VLANs usadas por la ONU</span>
    <p-multiSelect
      name="extra_vlans"
      [options]="lists['vlans_extra'] ?? []"
      optionLabel="label"
      optionValue="value"
      [filter]="true"
      display="chip"
      appendTo="body"
      styleClass="w-full"
      [(ngModel)]="model['extra_vlans']"
    />
    <small class="text-gray-500"
      >Después de cambiar las VLANs, asígnelas en los puertos Ethernet.</small
    >
  </label>
  }

  <!-- WiFi -->
  @case ('wifi') {
  <p class="font-semibold">
    {{ wifiPort?.port }} @if (wifiPort?.band) {
    <span class="font-normal text-gray-500">({{ wifiPort?.band }})</span> }
  </p>
  <div class="flex flex-wrap items-center gap-4">
    <span class="font-semibold">Estado</span>
    <label class="flex items-center gap-2">
      <p-radioButton
        name="wifi_port_is_enabled"
        value="1"
        [(ngModel)]="model['wifi_port_is_enabled']"
      />Habilitado
    </label>
    <label class="flex items-center gap-2">
      <p-radioButton
        name="wifi_port_is_enabled"
        value="0"
        [(ngModel)]="model['wifi_port_is_enabled']"
      />Deshabilitado
    </label>
  </div>
  <div class="flex flex-wrap items-center gap-4">
    <span class="font-semibold">Modo</span>
    @for (mode of wifiPortModes; track mode) {
    <label class="flex items-center gap-2">
      <p-radioButton
        name="wifi_port_mode"
        [value]="mode"
        [disabled]="mode === 'LAN' && view.mode['mode'] === 'Bridging'"
        [(ngModel)]="model['wifi_port_mode']"
      />{{ mode }}
    </label>
    }
  </div>
  @if (model['wifi_port_mode'] !== 'LAN') {
  <label class="flex flex-col gap-1">
    <span class="font-semibold">VLAN-ID</span>
    <p-dropdown
      name="wifi_vlan_id"
      [options]="lists['vlans_ethernet'] ?? []"
      optionLabel="label"
      optionValue="value"
      [loading]="!!loading['vlans_ethernet']"
      appendTo="body"
      styleClass="w-full"
      [(ngModel)]="model['wifi_vlan_id']"
    />
  </label>
  } @if (model['wifi_port_mode'] === 'Hybrid' || model['wifi_port_mode'] === 'Trunk') {
  <label class="flex flex-col gap-1">
    <span class="font-semibold">VLANs adicionales</span>
    <p-multiSelect
      name="wifi_port_extra_vlans"
      [options]="lists['vlans_ethernet'] ?? []"
      optionLabel="label"
      optionValue="value"
      display="chip"
      appendTo="body"
      styleClass="w-full"
      [(ngModel)]="model['wifi_port_extra_vlans']"
    />
  </label>
  }
  <label class="flex flex-col gap-1">
    <span class="font-semibold">SSID</span>
    <input
      pInputText
      name="ssid"
      maxlength="32"
      placeholder="Vacío: lo define el equipo"
      [(ngModel)]="model['ssid']"
    />
  </label>
  @if (model['ssid']) {
  <label class="flex flex-col gap-1">
    <span class="font-semibold">Autenticación</span>
    <p-dropdown
      name="auth_mode"
      [options]="authModes"
      optionLabel="label"
      optionValue="value"
      appendTo="body"
      styleClass="w-full"
      [(ngModel)]="model['auth_mode']"
    />
  </label>
  @if (model['auth_mode'] !== 'open_system') {
  <div class="flex flex-col gap-1">
    <span class="font-semibold">Contraseña</span>
    <div class="flex gap-2">
      <input
        pInputText
        class="flex-1"
        name="wifi_password"
        autocomplete="off"
        [type]="passwordVisible ? 'text' : 'password'"
        placeholder="Sin cambios: se mantiene la actual"
        [(ngModel)]="model['wifi_password']"
      />
      <p-button
        [icon]="passwordVisible ? 'pi pi-eye-slash' : 'pi pi-eye'"
        [text]="true"
        [loading]="passwordLoading"
        title="Ver contraseña"
        (onClick)="showWifiPassword()"
      />
    </div>
    <small class="text-gray-500">8 a 32 caracteres, sin espacios ni &amp;.</small>
  </div>
  } }
  <button
    type="button"
    class="self-start text-sm text-red-600 hover:underline"
    (click)="clearWifi()"
  >
    <i class="pi pi-eraser"></i> Limpiar SSID y contraseña
  </button>
  }

  <!-- Puerto Ethernet -->
  @case ('port') {
  <p class="font-semibold">Puerto {{ port?.port }}</p>
  <div class="flex flex-wrap items-center gap-4">
    <span class="font-semibold">Estado</span>
    <label class="flex items-center gap-2">
      <p-radioButton name="is_enabled" value="1" [(ngModel)]="model['is_enabled']" />Habilitado
    </label>
    <label class="flex items-center gap-2">
      <p-radioButton name="is_enabled" value="0" [(ngModel)]="model['is_enabled']" />Deshabilitado
    </label>
  </div>
  <div class="flex flex-wrap items-center gap-4">
    <span class="font-semibold">Modo</span>
    @for (mode of portModes; track mode) {
    <label class="flex items-center gap-2">
      <p-radioButton
        name="port_mode"
        [value]="mode"
        [disabled]="mode === 'LAN' && view.mode['mode'] === 'Bridging'"
        [(ngModel)]="model['port_mode']"
      />{{ mode }}
    </label>
    }
  </div>
  @if (model['port_mode'] !== 'LAN' && model['port_mode'] !== 'Transparent') {
  <label class="flex flex-col gap-1">
    <span class="font-semibold">VLAN-ID</span>
    <p-dropdown
      name="vlan_id"
      [options]="lists['vlans_ethernet'] ?? []"
      optionLabel="label"
      optionValue="value"
      [loading]="!!loading['vlans_ethernet']"
      appendTo="body"
      styleClass="w-full"
      [(ngModel)]="model['vlan_id']"
    />
  </label>
  } @if (model['port_mode'] === 'Hybrid' || model['port_mode'] === 'Trunk') {
  <label class="flex flex-col gap-1">
    <span class="font-semibold">VLANs adicionales</span>
    <p-multiSelect
      name="port_extra_vlans"
      [options]="lists['vlans_ethernet'] ?? []"
      optionLabel="label"
      optionValue="value"
      display="chip"
      appendTo="body"
      styleClass="w-full"
      [(ngModel)]="model['port_extra_vlans']"
    />
  </label>
  }
  <label class="flex flex-col gap-1">
    <span class="font-semibold">DHCP</span>
    <p-dropdown
      name="vlan_dhcp"
      [options]="view.options['vlan_dhcp'] ?? []"
      optionLabel="label"
      optionValue="value"
      appendTo="body"
      styleClass="w-full"
      [(ngModel)]="model['vlan_dhcp']"
    />
  </label>
  } }

  <div class="flex justify-end gap-2 border-t pt-3">
    <p-button label="Cancelar" [text]="true" severity="secondary" (onClick)="cancelled.emit()" />
    <p-button type="submit" label="Guardar" icon="pi pi-check" [loading]="saving" />
  </div>
</form>
